jQuery(function($)
{
    var
        // classAlwaysValidate = 'always-validate',
        classErrorGeneral = 'error',
        validationHandlers = orion.validation.handlers,
        errorClassesArray = toPropertyArray(validationHandlers, 'errorClass', [classErrorGeneral]),
        failureEventsArray = toPropertyArray(validationHandlers, 'failureEvent'),
        selectorInputsArray = toPropertyArray(validationHandlers, 'selectorInputs');

    function toPropertyArray(arr, property, seed)
    {
        var
            i,
            toArray = seed || [];

        for (i in arr)
        {
            if (Object.prototype.hasOwnProperty.call(arr, i))
            {
                toArray.push(arr[i][property]);
            }
        }

        return toArray;
    }

    function resetInputErrorState(input)
    {
        var $errorWrapper = $(input).data('error-wrapper')
            ? $(input).closest($(input).data('error-wrapper')) : $(input).closest('div');

        return $errorWrapper.removeClass(errorClassesArray.join(' ')).end();
    }

    function resetErrorState(form)
    {
        return $(selectorInputsArray.join(','), form).each(function()
        {
            resetInputErrorState(this);
        });
    }

    function conditionalValidation(input)
    {
        /*
		 * if the input has the attribute conditional-validation set to on,
		 * we check if the input is inside a folddown element, or an accordion-main element
		 * if the folddown element is not _opened_, we return true,
		 * which effectively skips any validation for this element
		 */

        var $folddown;

        if ($(input).attr('conditional-validation') !== 'on')
        {
            return false;
        }

        $folddown = $(input).closest('.folddown, .selected_box');
        if ($folddown.length === 0)
        {
            return false;
        }

        return !$folddown.hasClass('opened') && $folddown.hasClass('hidden');
    }

    function orCondition(input, o)
    {
        var
            validationOrGroup = $(input).data('validationOrGroup'),
            areValid = true;

        if (validationOrGroup !== undefined)
        {
            var $elements = $('*[data-validation-or-group="' +  validationOrGroup + '"]');

            areValid = false;
            $.each($elements, function(key, $element)
            {
                var $input = $($element);

                if (o.validation.apply($element, [$input]))
                {
                    areValid = true;
                }
            });
        }
        return areValid;
    }

    function validateTest(e, o)
    {
        var
            allPassed = true,
            $inputsFailed = $();
        if (0 === o.$inputs.length)
        {
            return true;
        }
        o.$inputs.each(function()
        {
            var
                validationOrGroup = $(this).data('validationOrGroup'),
                $input,
                passed;

            if (validationOrGroup !== undefined)
            {
                $input = $(this);
                passed = orCondition(this, o) || conditionalValidation(this);
            }
            else
            {
                $input = $(this);
                passed = o.validation.apply(this, [$input]) || conditionalValidation(this);
            }
            allPassed = allPassed && passed;
            if (!passed)
            {
                $inputsFailed = $inputsFailed.add($input);
            }
        });
        if (!allPassed)
        {
            if (e)
            {
                e.preventDefault();
            }
            o.$form.trigger(o.failureEvent, {
                '$inputsFailed': $inputsFailed,
                'errorClass': o.errorClass,
                'originEventType': (e ? e.type : null)
            });
            return false;
        }
        else if (allPassed && o.$form.hasClass('js-async-form') && !!e)
        {
            return true;
        }
    }

    function validateInput(input)
    {
        var
            $input = $(input),
            validationType, validationHandler;

        for (validationType in validationHandlers)
        {
            if (Object.prototype.hasOwnProperty.call(validationHandlers, validationType))
            {
                validationHandler = validationHandlers[validationType];
                if ('function' === typeof validationHandler.prerequisites)
                {
                    if (!validationHandler.prerequisites.apply($input, [$input]))
                    {
                        continue;
                    }
                }

                if ($input.is(validationHandler.selectorInputs))
                {
                    validateTest(false, {
                        '$form': $input.closest('form'),
                        '$inputs': $input,
                        'validation': validationHandler.validation,
                        'errorClass': validationHandler.errorClass,
                        'failureEvent': validationHandler.failureEvent
                    });
                }
            }
        }

        return input;
    }

    function handleSubmit(e)
    {
        resetErrorState(this);
        var
            form = this,
            $inputs,
            valid = true,
            lastValidation,
            validationType, validationHandler;

        for (validationType in validationHandlers)
        {
            if (Object.prototype.hasOwnProperty.call(validationHandlers, validationType))
            {
                validationHandler = validationHandlers[validationType];

                $inputs = $(form).find(validationHandler.selectorInputs);

                if ('function' === typeof validationHandler.prerequisites)
                {
                    $inputs = $inputs.filter(validationHandler.prerequisites);
                }

                lastValidation = validateTest(e, {
                    '$form': $(form),
                    '$inputs': $inputs,
                    'validation': validationHandler.validation,
                    'errorClass': validationHandler.errorClass,
                    'failureEvent': validationHandler.failureEvent
                });

                valid = valid && lastValidation;
            }
        }

        $(form).data('valid', valid);
        $(form).trigger(orion.constants.EventFormValidationComplete);
    }

    function handleInput()
    {
        var $this = $(this);

        /*
		 * if (!($this.hasClass(classAlwaysValidate) || $this.data("blurred") || $this.is(":radio, select"))) {
		 * 	console.log('bla1', $this.hasClass(classAlwaysValidate), !!$this.data("blurred"), $this.is(":radio, select"));
		 * 	return;
		 * }
		 */

        /*
		 * if (!($this.hasClass(classAlwaysValidate) || $this.closest("div").hasClass(classErrorGeneral) || $this.is(":radio, select"))) {
		 * 	console.log('bla2', $this.hasClass(classAlwaysValidate), $this.closest("div").hasClass(classErrorGeneral), $this.is(":radio, select"));
		 */

        /*
		 * 	return;
		 * }
		 */

        if ($this.is(validationHandlers.equalTo.selectorInputs))
        {
            validateInput(resetInputErrorState($('#' + $this.attr('equalto'))));
        }

        resetInputErrorState(this);
        validateInput(this);
    }

    function handleBlur()
    {
        $(this).data('blurred', true);
        resetInputErrorState(this);
        validateInput(this);
    }

    function handleInputFailed(e, data)
    {
        // e = e;

        data.$inputsFailed.each(function()
        {
            var $errorWrapper = $(this).data('error-wrapper')
                ? $(this).closest($(this).data('error-wrapper')) : $(this).closest('div');

            $errorWrapper.addClass(classErrorGeneral + ' ' + data.errorClass);
        });

        if ('submit' === data.originEventType)
        {
            $(this).trigger(orion.constants.EventValidationFailedOnSubmit, data);
        }
    }

    function handleValidationParametersChanged()
    {
        resetInputErrorState(this);
        validateInput(this);
    }

    function handleInitNext()
    {
        resetErrorState(this);
    }

    $('form')
        .on('submit', handleSubmit)
        .on(failureEventsArray.join(' '), handleInputFailed)
        .on('input', selectorInputsArray.join(','), handleInput)
        .on('change', selectorInputsArray.join(','), handleInput)
        .on('blur', selectorInputsArray.join(','), handleBlur)
        .on(orion.constants.EventValidationParametersChanged, selectorInputsArray.join(','),
            handleValidationParametersChanged)
        .on(orion.constants.EventFormValidate, handleSubmit)
        .on(orion.constants.EventFormInitNext, handleInitNext);
});
